import { type DimensionDefinition } from "./types";

export function makeDateDimension(): DimensionDefinition {
  const id = "date";

  return {
    id,
    name: "Date",
    getValue(row) {
      return row[id];
    },
    isDrillable: false,
  };
}

export function makeNameDimension(): DimensionDefinition {
  const id = "name";

  return {
    id,
    name: "Name",
    getValue(row) {
      return row[id];
    },
    isDrillable: false,
  };
}

export function makeAdKeyDimension(): DimensionDefinition {
  const id = "adKey";

  return {
    id,
    name: "Ad Key",
    getValue(row) {
      return row[id];
    },
    isDrillable: false,
  };
}

export function makeStatusDimension(): DimensionDefinition {
  const id = "status";

  return {
    id,
    name: "Status",
    getValue(row) {
      return row[id];
    },
    isDrillable: false,
  };
}

export function makeBreakdownDimension(
  breakdownName: string,
): DimensionDefinition {
  const id = `breakdown:${breakdownName}`;

  return {
    id,
    name: breakdownName,
    getValue(row) {
      return row.breakdowns?.[breakdownName];
    },
    isDrillable: true,
  };
}
